import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDatabase = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.0013 6.33431C11.4991 6.33431 14.3346 5.1404 14.3346 3.66764C14.3346 2.19488 11.4991 1.00098 8.0013 1.00098C4.5035 1.00098 1.66797 2.19488 1.66797 3.66764C1.66797 5.1404 4.5035 6.33431 8.0013 6.33431Z",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3327 6.33301C14.3327 7.80634 11.4967 8.99967 7.99935 8.99967C4.50202 8.99967 1.66602 7.80634 1.66602 6.33301",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.3327 9.33301C14.3327 10.8063 11.4967 11.9997 7.99935 11.9997C4.50202 11.9997 1.66602 10.8063 1.66602 9.33301",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.66602 3.66699V12.3337C1.66602 13.807 4.50202 15.0003 7.99935 15.0003C11.4967 15.0003 14.3327 13.807 14.3327 12.3337V3.66699",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgDatabase);
export default ForwardRef;
